import { getStatusPropertyName, getStatusPropertyValue } from 'framework-asset-preview-lib/internal/shared/utils/crmObject';
import { getObjectStatus } from 'framework-asset-preview-lib/internal/assetPreview/utils/getPreviewComponent';
import StatusPropertyValue from 'framework-asset-preview-lib/internal/properties/components/propertySections/StatusPropertyValue';
import { STATUS } from 'framework-asset-preview-lib/internal/shared/constants/assetPreview';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ObjectStatus({
  crmObject,
  nonCrmObject,
  useComponent = 'UITag',
  useDefaultComponent,
  doNotShowUnknown
}) {
  const propertyName = getStatusPropertyName(crmObject);
  if (!propertyName) {
    return null;
  }
  const StatusComponent = getObjectStatus(crmObject.objectTypeId);
  if (!useDefaultComponent && StatusComponent) {
    return /*#__PURE__*/_jsx(StatusComponent, {
      crmObject: crmObject
    });
  }
  const value = getStatusPropertyValue(crmObject, nonCrmObject);
  if ((!value || value === STATUS.DEFAULT) && doNotShowUnknown) {
    return null;
  }
  return /*#__PURE__*/_jsx(StatusPropertyValue, {
    useComponent: useComponent,
    value: value
  }, `StatusPropertyValue-${crmObject.objectId}`);
}